import { render, staticRenderFns } from "./frameless.vue?vue&type=template&id=41478030&scoped=true&"
import script from "./frameless.vue?vue&type=script&lang=js&"
export * from "./frameless.vue?vue&type=script&lang=js&"
import style0 from "./frameless.vue?vue&type=style&index=0&id=41478030&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41478030",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loaders: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/layout/loaders.vue').default,OfflineBar: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/global/offlineBar.vue').default,AppAnnouncement: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/layout/appAnnouncement.vue').default})
